import { ResizeAction, ResizeEvent } from './ResizeAction';

export { ResizeAction, type ResizeEvent };
export default ResizeAction;
